// import React, { useState } from "react";
// import {
//   Card,
//   CardMedia,
//   Grid,
//   Dialog,
//   DialogContent,
//   IconButton,
//   Box,
// } from "@mui/material";
// import { ArrowBack, ArrowForward } from "@mui/icons-material";
// import image1 from "../../images/home1.jpeg";
// import image2 from "../../images/home2.jpeg";
// import image3 from "../../images/home3.jpeg";
// import image4 from "../../images/home4.jpeg";
// import image5 from "../../images/homeImage1.jpeg";
// import image6 from "../../images/homeImage2.jpeg";
// import image7 from "../../images/homeImage3.jpeg";
// import image8 from "../../images/homeImage4.jpeg";
// import image9 from "../../images/homeImage5.jpeg";
// import image10 from "../../images/homeImage6.jpeg";

// const images = [image1, image2, image3, image4, image5, image6, image7, image8, image9, image10];

// const Portfolio = () => {
//   // State to handle modal visibility and image to display
//   const [open, setOpen] = useState(false);
//   const [selectedImage, setSelectedImage] = useState("");
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);

//   // Function to open the modal with the selected image
//   const handleImageClick = (image, index) => {
//     setSelectedImage(image);
//     setCurrentImageIndex(index);
//     setOpen(true);
//   };

//   // Function to close the modal
//   const handleClose = () => {
//     setOpen(false);
//   };

//   // Function to go to the next image in the carousel
//   const handleNext = () => {
//     const nextIndex = (currentImageIndex + 1) % images.length;
//     setSelectedImage(images[nextIndex]);
//     setCurrentImageIndex(nextIndex);
//   };

//   // Function to go to the previous image in the carousel
//   const handlePrev = () => {
//     const prevIndex = (currentImageIndex - 1 + images.length) % images.length;
//     setSelectedImage(images[prevIndex]);
//     setCurrentImageIndex(prevIndex);
//   };

//   return (
//     <Box sx={{ padding: "80px" }}>
//       {/* Grid to display 4 cards */}
//       <Grid container spacing={2}>
//         {images.map((item, index) => (
//           <Grid item xs={12} sm={6} md={3} key={item}>
//             <Card>
//               <CardMedia
//                 component="img"
//                 height="250"
//                 image={item} // Use the actual imported image here
//                 alt={`Image ${item}`}
//                 onClick={() => handleImageClick(item, index)} // Pass the actual image and index to the modal
//               />
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Modal to enlarge the image */}
//       <Dialog open={open} onClose={handleClose}>
//         <DialogContent sx={{ position: "relative", padding: 0 }}>
//           <img
//             src={selectedImage}
//             alt="Enlarged"
//             style={{
//               width: "600px",
//               height: "400px",
//               borderRadius: "15px",
//               objectFit: "contain",
//             }}
//           />

//           {/* Back Arrow */}
//           <IconButton
//             onClick={handlePrev}
//             sx={{
//               position: "absolute",
//               top: "50%",
//               left: "10px",
//               transform: "translateY(-50%)",
//               zIndex: 10,
//               backgroundColor: "rgba(0, 0, 0, 0.5)",
//               color: "white",
//             }}
//           >
//             <ArrowBack />
//           </IconButton>

//           {/* Forward Arrow */}
//           <IconButton
//             onClick={handleNext}
//             sx={{
//               position: "absolute",
//               top: "50%",
//               right: "10px",
//               transform: "translateY(-50%)",
//               zIndex: 10,
//               backgroundColor: "rgba(0, 0, 0, 0.5)",
//               color: "white",
//             }}
//           >
//             <ArrowForward />
//           </IconButton>
//         </DialogContent>
//       </Dialog>
//     </Box>
//   );
// };

// export default Portfolio;

import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { ArrowBack, ArrowForward, Close } from "@mui/icons-material";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";

// import image1 from "../../images/home1.jpeg";
// import image2 from "../../images/home2.jpeg";
import image3 from "../../images/home3.jpeg";
import image4 from "../../images/home4.jpeg";
import image5 from "../../images/homeImage1.jpeg";
import image6 from "../../images/homeImage2.jpeg";
import image7 from "../../images/homeImage3.jpeg";
import image8 from "../../images/homeImage4.jpeg";
import image9 from "../../images/homeImage5.jpeg";
import image10 from "../../images/homeImage6.jpeg";

const images = [
  // image1,
  // image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
];

const Portfolio = () => {
  const [open, setOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setOpen(true);
  };

  const handleNext = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ py: 10, px: 2, bgcolor: "#fdfdfd" }}>
      <Swiper
        effect="coverflow"
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={isMobile ? 1 : 3}
        loop={true}
        coverflowEffect={{
          rotate: 30,
          stretch: 0,
          depth: 150,
          modifier: 2.5,
          slideShadows: true,
        }}
        modules={[EffectCoverflow]}
        className="mySwiper"
        style={{ paddingBottom: "50px" }}
      >
        {images.map((img, index) => (
          <SwiperSlide key={index}>
            <Box
              component="img"
              src={img}
              alt={`Slide ${index}`}
              onClick={() => handleImageClick(index)}
              sx={{
                width: "100%",
                height: isMobile ? 250 : 350,
                objectFit: "cover",
                borderRadius: 3,
                boxShadow: 3,
                cursor: "pointer",
                transition: "transform 0.3s",
                "&:hover": { transform: "scale(1.03)" },
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Fullscreen Dialog */}
      <Dialog fullScreen open={open} onClose={handleClose}>
        <DialogContent
          sx={{
            bgcolor: "#000",
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 0,
          }}
        >
          {/* Image */}
          <Box
            component="img"
            src={images[currentImageIndex]}
            alt="Fullscreen"
            sx={{
              maxWidth: "100%",
              maxHeight: "100vh",
              objectFit: "contain",
            }}
          />

          {/* Close */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              backgroundColor: "rgba(255,255,255,0.2)",
              color: "#fff",
            }}
          >
            <Close />
          </IconButton>

          {/* Prev */}
          <IconButton
            onClick={handlePrev}
            sx={{
              position: "absolute",
              left: 20,
              top: "50%",
              transform: "translateY(-50%)",
              color: "#fff",
              backgroundColor: "rgba(255,255,255,0.1)",
            }}
          >
            <ArrowBack />
          </IconButton>

          {/* Next */}
          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              right: 20,
              top: "50%",
              transform: "translateY(-50%)",
              color: "#fff",
              backgroundColor: "rgba(255,255,255,0.1)",
            }}
          >
            <ArrowForward />
          </IconButton>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Portfolio;
